import { render, staticRenderFns } from "./matching-start.view.vue?vue&type=template&id=08e80ad6&scoped=true&"
import script from "./matching-start.view.vue?vue&type=script&lang=ts&"
export * from "./matching-start.view.vue?vue&type=script&lang=ts&"
import style0 from "./matching-start.view.vue?vue&type=style&index=0&id=08e80ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e80ad6",
  null
  
)

export default component.exports